<script>
import Show from "@/resources/auction/Show";

export default {
    extends: Show
};
</script>
